import { filterKeyParts, type QueryFilters } from '../core/queryKeyUtils';

export const managerKeys = {
  all: ['manager'] as const,
  dashboard: () => [...managerKeys.all, 'dashboard'] as const,
  bundle: {
    finance: (filters?: QueryFilters) =>
      [...managerKeys.all, 'bundle', 'finance', ...filterKeyParts(filters)] as const,
    employees: (filters?: QueryFilters) =>
      [...managerKeys.all, 'bundle', 'employees', ...filterKeyParts(filters)] as const,
  },
  branches: () => [...managerKeys.all, 'branches'] as const,
  branchTransfers: (filters?: QueryFilters) =>
    [...managerKeys.all, 'branch-transfers', ...filterKeyParts(filters)] as const,
  employees: () => [...managerKeys.all, 'employees'] as const,
  facebookMappings: () => [...managerKeys.all, 'facebook-mappings'] as const,
  facebookMappingDetail: (sheetName: string) =>
    [...managerKeys.facebookMappings(), 'detail', sheetName] as const,
  facebookMappingSummary: (sheetName: string) =>
    [...managerKeys.facebookMappings(), 'summary', sheetName] as const,
  facebookMappingSummaryRows: (sheetName: string, view: string) =>
    [...managerKeys.facebookMappings(), 'summary-rows', sheetName, view] as const,
  facebookMappingIssues: (sheetName: string) =>
    [...managerKeys.facebookMappings(), 'issues', sheetName] as const,
  facebookMappingDistribution: (sheetName: string) =>
    [...managerKeys.facebookMappings(), 'distribution', sheetName] as const,
} as const;
